import Promise from 'promise'

let storage = window.localStorage
let ev = window.execScript || window.eval
let loadProcess = {}
export default function loadFile (key, url) {
  if (loadProcess.key && loadProcess.key.state === 200) {
    return new Promise(resolve => resolve(true))
  } else if (loadProcess.key && loadProcess.key.state === 0) {
    return loadProcess.key.promise
  } else {
    loadProcess[key] = {
      key,
      state: 0
    }
    let promise = new Promise((resolve, reject) => {
      let val = storage.getItem('js-cache-' + key)
      let callback = function (cont) {
        try {
          ev(cont)
        } catch (e) {
        }
        loadProcess[key].state = 200
        resolve()
      }
      if (val) {
        callback(val)
      } else {
        let xhr = new XMLHttpRequest()
        xhr.onload = function () {
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              callback(xhr.responseText)
              setTimeout(function () {
                try {
                  storage.setItem('js-cache-' + key, xhr.responseText)
                } catch (e) {}
              }, 0)
            } else {
              reject(new Error('加载资料失败'))
            }
          }
        }
        xhr.open('GET', url)
        xhr.send(null)
      }
    })
    loadProcess[key].promise = promise
    return promise
  }
}
